import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import moment from "moment-timezone";
import IncidentBox from "../IncidentBox";
import { makeStyles } from "@mui/styles";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import React from "react";
import "./index.css";
export default function ProductCard(props: any) {
  const [scheduledIncs, setScheduledInc]: any = React.useState(
    props.data.scheduledInc
  );
  const [liveInc, setLiveInc]: any = React.useState(
    props.data.data.liveIncidents
  );
  let [liveIncIndex, setLiveIncIndex]: any = React.useState(0);
  const [components, setComponents] = useState(props.data.data.components);
  let regionsData = props.componentsList;
  const [status, setStatus] = useState("");
  const tabsConstant = {
    0: "All",
    1: ["US"],
    2: ["EUC", "EU Central"],
    3: ["IND"],
    4: ["AUS", "AU"],
    5: ["MEA", "Middle East", "Africa", "MIDDLE EAST AND AFRICA (MEA)"],
  };
  const issues: string[] = [];
  const prodIssues: any = [];
  regionsData.forEach((region) => {
    if (issues.indexOf(region.status) === -1 && region.status !== "OP") {
      issues.push(region.status);
    }
    if (region.status !== "OP") {
      prodIssues.push(region);
    }
  });
  regionsData = regionsData.map((region) => {
    region.compIssueList = [];
    region.compIssueList =
      region.components && region.components.length > 0
        ? region.components.map((reg) => reg.id.toString())
        : [];
    region.compIssueList.push(region.id.toString());
    return region;
  });
  const getStatus = (components, res, liveInc) => {
    const statusArr: any = [];
    let status: any;
    components.forEach((item) => {
      statusArr.push(item.status);
    });
    const total = statusArr.length;
    const isMO = statusArr.filter((a) => a === "MO").length;
    const isPO = statusArr.filter((a) => a === "PO").length;
    const isPD = statusArr.filter((a) => a === "PD").length;
    const isUM = statusArr.filter((a) => a === "UM").length;
    if (total === 0) {
      status = "OP";
    } else if (isMO === total) {
      status = "MO";
    } else if (isPO === total) {
      status = "PO";
    } else if (isPD === total) {
      status = "PD";
    } else if (isUM === total) {
      status = "UM";
    } else if (statusArr.find((a) => a === "MO")) {
      status = "PO";
    } else if (statusArr.find((a) => a === "PO")) {
      status = "PO";
    } else if (statusArr.find((a) => a === "PD")) {
      status = "PD";
    } else if (statusArr.find((a) => a === "UM")) {
      status = "UM";
    } else if (liveInc && liveInc.length) {
      status = "PO";
    } else if (res.onGoingMaintenance && res.onGoingMaintenance.length) {
      status = "UM";
    } else {
      status = "OP";
    }
    return status;
  };

  useEffect(() => {
    const regionsData = props.data.data.componentsList.filter((comp) => {
      return tabsConstant[props.currentTab].includes(comp.regionName);
    });
    const filteredComponents =
      props.currentTab !== 0
        ? props.data.data.components.filter(
            (component) =>
              component.id === regionsData[0].id ||
              component["group_id"] === regionsData[0].id
          )
        : props.data.data.components;
    setComponents(filteredComponents);

    const componentsIds = filteredComponents.map((component) =>
      component.id.toString()
    );
    const liveIncidents = props.data.data.liveIncidents.filter((inc) => {
      inc["affected_components_filtered"] = inc["affected_components"];
      const filteredAffectedComponents = inc[
        "affected_components_filtered"
      ].filter((affected: any) => {
        return componentsIds.includes(affected.component);
      });
      if (filteredAffectedComponents.length > 0) {
        inc["affected_components_filtered"] = filteredAffectedComponents;
        return inc;
      } else {
        return null;
      }
    });
    setLiveInc(liveIncidents);
    setStatus(getStatus(filteredComponents, props.data.data, liveIncidents));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.componentsList, props.currentTab]);

  useEffect(() => {
    let scheudleIncs = [
      ...(props.data.scheduledInc || []),
      ...(props.data.data.onGoingMaintenance || []),
    ];

    scheudleIncs = scheudleIncs.reduce((unique, o) => {
      if (!unique.some((obj) => obj.title === o.title)) {
        unique.push(o);
      }
      return unique;
    }, []);
    const regionsData = props.data.data.componentsList.filter((comp) => {
      return tabsConstant[props.currentTab].includes(comp.regionName);
    });
    const filteredComponents =
      props.currentTab !== 0
        ? props.data.data.components.filter(
            (component) =>
              component.id === regionsData[0].id ||
              component["group_id"] === regionsData[0].id
          )
        : props.data.data.components;
    const componentsIds = filteredComponents.map((component) =>
      component.id.toString()
    );
    let scheduleFiltered = scheudleIncs.filter((inc) => {
      inc["affected_components_filtered"] = inc["affected_components"];
      const filteredAffectedComponents = inc[
        "affected_components_filtered"
      ].filter((affected: any) => {
        return componentsIds.includes(affected.component);
      });
      if (filteredAffectedComponents.length > 0) {
        inc["affected_components_filtered"] = filteredAffectedComponents;
        return inc;
      } else {
        return null;
      }
    });

    scheduleFiltered = scheduleFiltered?.sort((a, b) => {
      const startTimeA = new Date(a.scheduled_start_time);
      const startTimeB = new Date(b.scheduled_start_time);

      if (startTimeA < startTimeB) return -1;
      if (startTimeA > startTimeB) return 1;
      return 0;
    });
    setScheduledInc(scheduleFiltered);
    props.setScheduledIncProdCount(scheduleFiltered.length, props.data.name);
  }, [props.currentTab, props.currentIncidentTab]);

  const scheudleBox = {
    minHeight: "60px",
    margin: "0px 16px 8px 16px",
    "@media (max-width: 992px)": {
      margin: "0px 16px 8px 16px",
    },
  };
  const scheudleBoxInside = {
    minHeight: "60px",
    borderRadius: "8px",
  };
  const scheudleMain = {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
  };
  const scheudleMaiDesc = {
    maxHeight: "100px",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    lineClamp: "3",
    boxOrient: "vertical",
    overflow: "hidden",
    color: "var(--S500, #647A8E)",
    "@media (max-width: 992px)": {
      display: "block",

      color: "var(--S500, #647A8E)",
      fontSize: "12px",
      lineHeight: "16px",
      padding: "10px 0 10px 0",
      maxHeight: "60px",
    },
  };

  const [showDetailsHover, setShowDetailsHover] = useState(false);
  const iconSx = { height: "24px", width: "24px" };
  const productName = {
    postion: "relative",
    top: "-2px",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    "@media (max-width: 992px)": {
      fontSize: "15px",
    },
  };
  const card = {
    minHeight: "75px",
    borderRadius: "none",
    // add a hover state to the card
    "&:hover": {
      cursor: "pointer",
      boxShadow: "0px 0px 5px 2px #95959540",
      border: "1px solid #CFD7DF",
      background:
        "linear-gradient(0deg, #F5F7F9, #F5F7F9), linear-gradient(0deg, #CFD7DF, #CFD7DF)",
    },
  };
  const cardBanner = {
    height: "60px",
  };
  const codeToText = {
    PO: "Partial Outage",
    PD: "Performance Degradation",
    OP: "Operational",
    UM: "Under Maintenance",
    MO: "Major Outage",
  };
  const colorCode: any = {
    PO: {
      color: "#D7461F",
      background: "#FEF1E1",
      padding: "0 16px",
    },
    PD: {
      background: "rgba(217, 154, 15, 0.06)",
      color: "#D99A0F",
      padding: "0 16px",
    },
    OP: {
      color: "#00795B",
      backgroundColor: "#E0F5F1",
      padding: "0 16px",
    },
    UM: {
      color: "#2C5CC5",
      backgroundColor: "#F5F8FA",
      background: "#E5F2FD",
      padding: "0 16px",
    },
    MO: {
      color: "#D7461F",
      background: "rgba(215, 70, 31, 0.06)",
      padding: "0 16px",
    },
  };

  const prodColor = props.data.status.split(/(?<=^\S+)\s/)[0].toLowerCase();
  // color: colorCode[`${prodColor}`],
  const color = {
    postion: "relative",
    top: "-2px",
  };
  // backgroundColor: colorCode[`${prodColor}`].backgroundColor,
  const cardContent = {
    display: "flex",
    justifyContent: "center",
    padding: "8px 16px 16px 16px",
  };
  const prodState = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    height: "34px",
    "@media (max-width: 992px)": {
      fontSize: "12px",
      lineHeight: "18px",
      height: "24px",
    },
  };
  const regionStatus = (status) => {
    const statusStyle = colorCode[status];
    return {
      ...statusStyle,
      borderRadius: "4px",
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "20px",
      padding: "3px",
      marginRight: "3px",
    };
  };
  const incidentsCount = {
    marginTop: "8px",
    fontSize: "14px",
  };

  const StyledCardActionArea = styled(CardActionArea)(
    ({ theme }) => `
  .MuiCardActionArea-focusHighlight {
      background: transparent;
  }
`
  );
  const useStyles = makeStyles({
    root: {
      boxShadow: "none",
      borderLeft: "1px solid #CFD7DF",
      borderRadius: "0px",
      borderBottom: "1px solid #CFD7DF",
      borderTop: props.currentProductIndex === 0 ? "1px solid #CFD7DF" : "none",
      borderRight: "1px solid #CFD7DF",
      borderTopLeftRadius:
        props.currentProductIndex === 0 ? "5px" : "0 !important",
      borderTopRightRadius:
        props.currentProductIndex === 0 ? "5px" : "0 !important",
      borderBottomLeftRadius:
        props.currentProductIndex === props.totalProducts
          ? "5px"
          : "0 !important",
      borderBottomRightRadius:
        props.currentProductIndex === props.totalProducts
          ? "5px"
          : "0 !important",
    },
  });

  const classes = useStyles();
  const scheduledInc = scheduledIncs;
  const [scheduledIncIndex, setScheduledIncIndex] = useState(0); 
  return props.currentIncidentTab === "maintenances" &&
    scheduledInc &&
    scheduledInc.length === 0 ? (
    <></>
  ) : (
    <Card sx={card} className={classes.root}>
      <StyledCardActionArea
        onClick={(e) => {
          window.open(props.data.link, "_blank");
        }}
      >
        <Box
          display="flex"
          sx={cardBanner}
          alignItems="center"
          justifyContent="space-between"
          mx={3}
        >
          <Box display="flex" alignItems="center">
            <Box sx={iconSx} mr={1}>
              <img
                src={`/${props.data.name.toLowerCase()}-dew.svg`}
                height={24}
                width={24}
                alt={props.data.name}
              />
            </Box>
            <Box sx={productName}>{props.data.name}</Box>
          </Box>
          {props.currentIncidentTab === "status" ? (
            <Box display="flex">
              {(liveInc && liveInc.length > 0) ||
              (props.data.data.onGoingMaintenance &&
                props.data.data.onGoingMaintenance.length > 0) ||
              (props.data.scheduledInc &&
                props.data.scheduledInc.length > 0) ? (
                  <Box sx={{    ...colorCode["MO"],
                    ...prodState,
                    fontWeight: 600,
                    color: "rgb(192, 38, 0) !important",}}>
                  {codeToText["MO"]}
                </Box>
              ) : (
                <Box
                  sx={{
                    ...colorCode["MO"],
                    ...prodState,  fontWeight: 600,
                    color: "rgb(192, 38, 0) !important",
                  }}
                >
                  {codeToText["MO"]}
                </Box>
              )}
            </Box>
          ) : (
            ""
          )}
        </Box>
        {props.currentIncidentTab === "maintenances" ? (
          scheduledInc && scheduledInc.length > 0 ? (
            <Box sx={scheudleBox}>
              <Box
                sx={scheudleBoxInside}
                px={2}
                py={1}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                >
                  <Box sx={scheudleMain}>
                    {scheduledInc[scheduledIncIndex].title} |{" "}
                    {moment(
                      scheduledInc[scheduledIncIndex].scheduled_start_time
                    ).format("MMMM Do YYYY, h:mm a")}{" "}
                    IST -{" "}
                    {moment(
                      scheduledInc[scheduledIncIndex].scheduled_end_time
                    ).format("MMMM Do YYYY, h:mm a")}{" "}
                    IST
                  </Box>

                  {scheduledInc.length > 1 ? (
                    <Box
                      display="flex"
                      flexDirection="row"
                      sx={{ width: "60px" }}
                    >
                      <Box sx={{ width: "30px" }}>
                        <button
                          className="leftArrow"
                          disabled={scheduledIncIndex === 0 ? true : false}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setScheduledIncIndex(scheduledIncIndex - 1);
                          }}
                        >
                          <KeyboardArrowLeftOutlinedIcon
                            sx={{ right: "5px", position: "relative" }}
                          />
                        </button>
                      </Box>
                      <Box sx={{ width: "30px" }}>
                        <button
                          className="rightArrow"
                          disabled={
                            scheduledInc.length === scheduledIncIndex + 1 ||
                            scheduledInc.length === 1
                              ? true
                              : false
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setScheduledIncIndex(scheduledIncIndex + 1);
                          }}
                        >
                          {" "}
                          <KeyboardArrowRightOutlinedIcon
                            sx={{ right: "5px", position: "relative" }}
                          />
                        </button>
                      </Box>
                    </Box>
                  ) : (
                    ``
                  )}
                </Box>
                <Box sx={scheudleMaiDesc}>
                  {scheduledInc[scheduledIncIndex].description}{" "}
                </Box>
              </Box>
            </Box>
          ) : (
            ""
          )
        ) : (
          ""
        )}
        {props.currentIncidentTab === "status" ? (
          liveInc && liveInc.length > 0 ? (
            <CardContent
              id={`${props.data.name}-cardContent`}
              className="cardContent"
              sx={cardContent}
            >
              <Box sx={{ width: "100%" }}>
                <IncidentBox
                  key={liveIncIndex}
                  productName={props.data.name}
                  incidentDetails={liveInc[liveIncIndex]}
                  incidentClass={"liveincident"}
                  components={components}
                  componentGroups={props.data.data.componentGroups}
                  accountId={props.data.freshStatusAccountNumber}
                />
                {liveInc.length > 1 ? (
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="end"
                    alignItems="center"
                    sx={incidentsCount}
                  >
                    <Box sx={{ marginRight: "10px" }}>
                      <b>{liveIncIndex + 1}</b>/{liveInc.length} Incidents
                    </Box>
                    <Box sx={{ width: "30px" }}>
                      <button
                        className="leftArrow"
                        disabled={liveIncIndex === 0 ? true : false}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          setLiveIncIndex(liveIncIndex - 1);
                        }}
                      >
                        <KeyboardArrowLeftOutlinedIcon
                          sx={{ right: "5px", position: "relative" }}
                        />
                      </button>
                    </Box>
                    <Box sx={{ width: "30px" }}>
                      <button
                        className="rightArrow"
                        disabled={
                          liveInc.length === liveIncIndex + 1 ||
                          liveInc.length === 1
                        }
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          setLiveIncIndex(liveIncIndex + 1);
                        }}
                      >
                        {" "}
                        <KeyboardArrowRightOutlinedIcon
                          sx={{ right: "5px", position: "relative" }}
                        />
                      </button>
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
              </Box>
            </CardContent>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </StyledCardActionArea>
    </Card>
  );
}
